import { UPDATE_USER_SITES } from "./actionTypes";

export function updateUserSites({ projects, sites, projectGroups }) {
  return {
    type: UPDATE_USER_SITES,
    projects,
    sites,
    projectGroups,
  };
}
